import { FormControlLabel, Paper, Switch, Typography } from "@mui/material";
import { useNewUi } from "../../contexts/NewUiContext";

function NewUiToggle() {
  const { isNewUiEnabled, setNewUiEnabled } = useNewUi();

  return (
    <Paper
      elevation={8}
      sx={{
        position: "fixed",
        left: {
          xs: "max(8px, env(safe-area-inset-left))",
          sm: "max(16px, env(safe-area-inset-left))",
        },
        bottom: {
          xs: "calc(72px + env(safe-area-inset-bottom))",
          sm: "max(16px, env(safe-area-inset-bottom))",
        },
        zIndex: 2000,
        px: { xs: 0.75, sm: 1.25 },
        py: { xs: 0.35, sm: 0.75 },
        borderRadius: { xs: 1.5, sm: 2 },
        width: "auto",
        maxWidth: "none",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          display: { xs: "none", sm: "block" },
          px: { xs: 0, sm: 1 },
          opacity: 0.7,
          fontSize: { xs: "0.68rem", sm: "0.72rem" },
        }}
      >
        Interface
      </Typography>
      <FormControlLabel
        sx={{
          m: 0,
          ml: { xs: 0.25, sm: 0 },
          ".MuiFormControlLabel-label": {
            fontSize: { xs: "0.84rem", sm: "0.9rem" },
          },
        }}
        control={
          <Switch
            size="small"
            disableRipple
            checked={isNewUiEnabled}
            onChange={(_, checked) => setNewUiEnabled(checked)}
          />
        }
        label="New Ui"
      />
    </Paper>
  );
}

export default NewUiToggle;
